export default class Toast {
    constructor() {

        this.el = document.querySelector('#toast')
        if (this.el == undefined) { return false; }
        this.closeButton = document.querySelector('.close-toast')
        this.init = this.init.bind(this)
        this.displayToast = this.displayToast.bind(this)
        this.closeWindow = this.closeWindow.bind(this)
        this.init()
    }
    init() {
        this.closeButton.addEventListener('click', ev => this.closeWindow())
    }

    displayToast() {
        this.el.classList.remove('toast-hide')
        this.el.classList.add('toast-display')
        setTimeout(() => {
            this.closeWindow()
        }, 5000)
    }

    closeWindow() {
        this.el.classList.remove('toast-display')
        this.el.classList.add('toast-hide')
    }


}

